export default __webpack_public_path__ + "static/media/division.abcb797c.png";